<template>
  <div class="view-container">
    <BjDrawerForm
      ref="BjDrawerForm"
      :form="form"
      :rules="rules"
      label-width="120px"
      @handleConfirm="handleConfirm"
    >
      <BjDivider>{{ $t('screenWMS.sortingStation') }}</BjDivider>
      <el-row>
        <el-col :span="colSpan">
          <el-form-item :label="$t('screenWMS.sortingStation')" prop="sortingStationNumber">
            <BjInputNumber v-model="form.sortingStationNumber" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('screenWMS.sortingStation')" clearable/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="colSpan">
          <el-form-item :label="$t('screenWMS.shelves')" prop="shelvesNumber">
            <BjInputNumber v-model="form.shelvesNumber" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('screenWMS.shelves')" clearable/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="colSpan">
          <el-form-item :label="$t('screenWMS.Equipment')" prop="lampNo">
            <BjInput v-model="form.lampNo" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('screenWMS.Equipment')" clearable/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="colSpan">
          <el-form-item :label="$t('screenWMS.basketS')" prop="basketNumberStart">
            <BjInputNumber v-model="form.basketNumberStart" :disabled="isEdit" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('screenWMS.basketS')" clearable/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="colSpan">
          <el-form-item :label="$t('screenWMS.basketE')" prop="basketNumberEnd">
            <BjInputNumber v-model="form.basketNumberEnd" :disabled="isEdit" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('screenWMS.basketE')" clearable/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="colSpan">
          <el-form-item :label="$t('screenWMS.address')" prop="largeScreenAddress">
            <BjInput v-model="form.largeScreenAddress" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('screenWMS.address')" clearable/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="colSpan">
          <el-form-item :label="$t('screenWMS.Printer')" prop="printerInformation">
            <BjInput v-model="form.printerInformation" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('screenWMS.Printer')" clearable/>
          </el-form-item>
        </el-col>
      </el-row>
    </BjDrawerForm>
  </div>
</template>
<script>
import { waveApi } from '@/api';

const getDefaultForm = () => {
  return {
    sortingStationNumber: null,
    shelvesNumber: null,
    lampNo: null,
    basketNumberStart: null,
    basketNumberEnd: null,
    largeScreenAddress: null,
    printerInformation: null,
  };
};

export default {
  data() {
    return {
      // 表单参数
      isEdit: false,
      colSpan:24,
      form: getDefaultForm(),
    };
  },
  computed: {
    // 表单校验
    rules() {
      const validate = (rule, value, callback) => {
        this.$nextTick(() => {
          if (!value) {
            callback(new Error(this.$t('inputText')));
          }
          if (this.form.basketNumberStart >= this.form.basketNumberEnd) {
            callback(new Error(this.$t('screenWMS.ps1')));
          }
          callback();
        });
      };
      const validateAddress = (rule, value, callback) => {
        this.$nextTick(() => {
          if (!value) {
            callback(new Error(this.$t('inputText')));
          }
          if (!this.form.largeScreenAddress.includes('/')) {
            callback(new Error(this.$t('screenWMS.ps2')));
          }
          callback();
        });
      };
      return {
        sortingStationNumber: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        shelvesNumber: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        lampNo: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        basketNumberStart: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        basketNumberEnd: [{ required: true, validator: validate, trigger: 'blur' }],
        largeScreenAddress: [{ required: true, validator: validateAddress, trigger: 'blur' }],
        printerInformation: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      };
    },
  },
  methods: {
    show(info) {
      this.isEdit = !!info;
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(
        this.isEdit ? this.$t('editText') : this.$t('addText'),
      );
      this.form = Object.assign(getDefaultForm(), info || {});
    },
    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      if (this.isEdit) {
        this.editApi(API_DATA);
      }else{
        this.addApi(API_DATA);
      }
    },
    editApi(API_DATA) {
      waveApi.editSortingStation(API_DATA).then(res => {
        if (res.code == 200) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }else{
          this.$message.error(res.msg);
        }
      });
    },
    addApi(API_DATA) {
      waveApi.addSortingStation(API_DATA).then(res => {
        if (res.code == 200) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }else{
          this.$message.error(res.msg);
        }
      });
    },
    reFresh() {
      this.$emit('reFresh');
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
::v-deep .el-checkbox__label {
  width: 125px;
  height: 30px;
}
</style>
